import { useState } from 'react'

export const usePassword = () => {
  const [showPassword, setShowPassword] = useState(false)

  const onSwitchShowPassword = () => {
    setShowPassword(!showPassword)
  }
  return { showPassword, onSwitchShowPassword }
}
